const en = {
  langName: 'English',
  brand: {
    name: 'BULLISH',
    descriptor: 'TAX & ADVISORY',
    tagline: 'Strategy Behind Every Decision.',
    secondary: 'Built Around Your Next Move.',
    legal: 'Bullish Accounting LLC',
  },
  nav: {
    whoWeServe: 'Who We Help',
    expertise: 'Services',
    plans: 'Accounting Plans',
    allExpertise: 'All expertise',
    howWeWork: 'How We Work',
    about: 'About Us',
    insights: 'Insights',
    book: 'Request a Strategy Session',
    menu: 'Menu',
    close: 'Close',
    language: 'Language',
    skip: 'Skip to content',
  },
  common: {
    learnMore: 'Learn more',
    explore: 'Explore',
    bookCta: 'Request a Strategy Session',
    exploreExpertise: 'Explore Our Services',
    relatedExpertise: 'Related expertise',
    individualAnalysis:
      'Every situation is different. The considerations described here are general in nature and each matter requires individual analysis before any recommendation is made.',
    placeholder: 'Placeholder',
  },
  seo: {
    home: {
      title: 'Bullish Accounting | Strategic Tax & Advisory',
      description:
        'Strategic tax planning, international taxation, U.S. investment tax and accounting advisory for business owners and international investors.',
    },
    investors: {
      title: 'International Investors & U.S. Tax | Bullish Accounting',
      description:
        'U.S. tax guidance for foreign investors: ownership structures, real estate, FIRPTA and international information reporting, in English and Spanish.',
    },
    owners: {
      title: 'Tax Advisory for Business Owners | Bullish Accounting',
      description: 'Tax planning, complex compliance, accounting and ongoing advisory for U.S. business owners and growing companies.',
    },
    expertise: {
      title: 'Our Expertise | Bullish Accounting',
      description:
        'Strategic tax planning, international and cross-border tax, U.S. real estate tax, business tax compliance and accounting advisory.',
    },
    strategic: {
      title: 'Strategic Tax Planning | Bullish Accounting',
      description: 'Proactive U.S. tax planning for business owners, investors and complex business situations, built around the decisions ahead.',
    },
    international: {
      title: 'International & Cross-Border Tax | Bullish Accounting',
      description:
        'Foreign-owned U.S. entities, Forms 5471, 5472, 8865, 1040-NR and 1120-F, FIRPTA, foreign tax credits and treaty considerations.',
    },
    realestate: {
      title: 'U.S. Investment & Real Estate Tax | Bullish Accounting',
      description: 'Tax considerations for foreign investors in U.S. real estate: rental properties, ownership structures and property transactions.',
    },
    business: {
      title: 'Business Tax & Complex Compliance | Bullish Accounting',
      description: 'Business tax preparation and compliance for partnerships, corporations, S corporations and complex ownership structures.',
    },
    accounting: {
      title: 'Accounting & Ongoing Advisory | Bullish Accounting',
      description: 'Accounting, bookkeeping, financial reporting and tax-ready records, with ongoing advisory and payroll and sales tax support.',
    },
    howWeWork: {
      title: 'How We Work | Bullish Accounting',
      description: 'From initial qualification and a strategic consultation to a customized proposal and ongoing advisory. Every engagement is quoted individually.',
    },
    about: {
      title: 'About Bullish | Bullish Accounting',
      description: 'An independent, founder-led U.S. tax and advisory firm serving business owners and international investors in English and Spanish.',
    },
    insights: {
      title: 'Insights | Bullish Accounting',
      description: 'Educational perspectives on U.S. tax planning and cross-border compliance. Coming soon.',
    },
    plans: {
      title: 'Accounting & Advisory Plans | Bullish Accounting',
      description: 'Basic, Basic Plus, Quarterly and Monthly accounting plans, coordinated with your federal and state tax filings. Quoted individually.',
    },
    book: {
      title: 'Request a Strategy Session | Bullish Accounting',
      description: 'Tell us about your situation and request a strategic consultation with the founders of Bullish. We review every request individually.',
    },
    review: {
      title: 'Share Your Experience | Bullish Accounting',
      description: 'Thank you for trusting Bullish Accounting. Share your experience with our team.',
    },
    privacy: { title: 'Privacy Policy | Bullish Accounting', description: 'How Bullish Accounting LLC collects, uses and protects information submitted through bullishaccounting.com.' },
    terms: { title: 'Terms of Use | Bullish Accounting', description: 'Terms governing the use of bullishaccounting.com, the website of Bullish Accounting LLC.' },
    disclaimer: {
      title: 'Professional Disclaimer | Bullish Accounting',
      description: 'Professional services disclaimer for Bullish Accounting LLC.',
    },
  },
  home: {
    hero: {
      overline: 'U.S. Tax · International · Advisory',
      h1: 'Strategic Tax Advice for Business Owners and International Investors.',
      text: 'U.S. tax planning, international tax compliance, and accounting advisory designed around complex decisions, growing businesses, and cross-border opportunities.',
      values: [
        { t: 'Clarity', d: 'A clear view of your U.S. tax position' },
        { t: 'Confidence', d: 'Before important financial decisions' },
        { t: 'Informed decisions', d: 'Grounded in organized financial information' },
        { t: 'Ongoing support', d: 'With direct access to the founders' },
      ],
    },
    serve: {
      overline: 'Who We Help',
      title: 'Two kinds of clients. One standard of advice.',
      intro: 'Our work is focused on two groups whose tax decisions tend to carry the most consequence — and the most opportunity.',
    },
    expertise: {
      overline: 'Our Services',
      title: 'Advice organized around the decisions you are facing.',
      intro: 'Five areas of practice, each with its own depth. Accounting remains part of what we do — in service of better tax and business decisions.',
    },
    why: {
      overline: 'Why Bullish',
      title: 'A founder-led firm, by design.',
      intro: 'We keep our practice deliberately focused so that every client relationship receives senior attention and strategic thinking.',
      items: [
        { title: 'Direct access to the founders', text: 'You work directly with the people responsible for your matter — not a rotating team.' },
        { title: 'Personalized advisory relationships', text: 'Advice is built around your goals, your structure and your timeline.' },
        { title: 'U.S. and international experience', text: 'We work with domestic matters and with the cross-border questions that arise when people, capital and entities span more than one country.' },
        { title: 'Strategy beyond annual filing', text: 'Filing is the outcome. The value is in the planning and decisions made throughout the year.' },
        { title: 'Integrated tax and accounting', text: 'We look at your books and your tax position together, so one supports the other.' },
        { title: 'English and Spanish', text: 'Clear communication in the language you are most comfortable with.' },
      ],
    },
    process: {
      overline: 'How We Work',
      title: 'A clear path from first conversation to ongoing support.',
      cta: 'See engagement models',
    },
    leadership: {
      overline: 'Leadership',
      title: 'Meet the founders.',
      cta: 'About Bullish',
    },
    final: {
      title: 'Facing an important decision?',
      text: 'Start with a strategic consultation. We will review your situation, identify the key questions, and outline how we can help.',
      secondary: 'How we work',
    },
  },
  process: [
    { title: 'Initial qualification', text: 'You share a brief description of your situation. We confirm whether it fits our practice before anything is arranged.' },
    { title: 'Strategic consultation', text: 'A focused session with a founder to understand your objectives, structure and the questions that matter most.' },
    { title: 'Situation and needs assessment', text: 'We analyze the information discussed and identify obligations, risks and planning opportunities.' },
    { title: 'Customized engagement proposal', text: 'You receive a written proposal with scope, deliverables, timing and fees tailored to your matter.' },
    { title: 'Implementation and ongoing support', text: 'When applicable, we carry out the work and remain available as your situation evolves.' },
  ],
  audiences: {
    investors: {
      name: 'International Investors & U.S. Real Estate',
      short:
        'Foreign investors — particularly those with Latin American connections — who need guidance on U.S. taxation, ownership structures, real estate investments and international tax compliance.',
      overline: 'Who We Serve',
      h1: 'Tax guidance for international investors in the United States.',
      intro:
        'Investing in the United States from abroad raises questions that domestic investors rarely face: how to hold the investment, what must be reported, how income and sales are taxed, and how U.S. rules interact with your home country. We help you understand those questions before decisions are made — and stay compliant afterwards.',
      challengesTitle: 'Questions we commonly help clients work through',
      challenges: [
        'How should a U.S. property or business interest be owned — individually, through a U.S. entity, or another structure?',
        'What U.S. filing and information-reporting obligations apply to a foreign owner?',
        'How is rental income taxed, and which deductions may be available?',
        'What happens from a tax perspective when a U.S. property is sold, including FIRPTA withholding?',
        'How may a tax treaty or foreign tax credits affect the overall result?',
        'How should legal structuring and estate planning be coordinated with qualified attorneys?',
      ],
      approachTitle: 'How we work with international investors',
      approach: [
        'Communication in English and Spanish, with explanations adapted to clients who are new to the U.S. system.',
        'Analysis of the U.S. tax implications of your structure before you invest, when possible.',
        'Coordination with your attorneys and advisors in the United States and abroad.',
        'Ongoing compliance so reporting obligations are met each year.',
      ],
      services: ['international', 'realestate', 'strategic'],
    },
    owners: {
      name: 'Business Owners & Growing Companies',
      short:
        'Business owners and growing companies that need tax planning, complex compliance, accounting and ongoing advisory as their operations become more sophisticated.',
      overline: 'Who We Serve',
      h1: 'Tax strategy and advisory for business owners and growing companies.',
      intro:
        'As a business grows, so does the cost of reactive tax decisions. Entity choices, owner compensation, multi-owner arrangements, expansion and reporting all benefit from a planned approach. We work with owners who want a tax and accounting partner that thinks ahead.',
      challengesTitle: 'Where we typically add value',
      challenges: [
        'Planning the tax impact of major decisions before they are made.',
        'Reviewing whether the current entity and ownership structure still fits the business.',
        'Managing compliance for partnerships, corporations and S corporations.',
        'Keeping accounting records accurate, timely and ready for tax reporting.',
        'Coordinating payroll and sales tax obligations where applicable.',
        'Addressing cross-border questions when owners, customers or operations are outside the U.S.',
      ],
      approachTitle: 'How we work with business owners',
      approach: [
        'Direct access to a founder who understands both your tax position and your books.',
        'Year-round planning conversations, not only at filing time.',
        'Clear proposals with defined scope and fees.',
        'Accounting support sized to what your business actually needs.',
      ],
      services: ['strategic', 'business', 'accounting'],
    },
  },
  expertisePage: {
    overline: 'Our Services',
    h1: 'Depth where it matters most.',
    intro:
      'Our practice is organized around five areas. Strategic tax planning and international work lead our practice; accounting and compliance support the decisions behind them.',
  },
  serviceLabels: {
    scope: 'What this can include',
    whoFor: 'Who this is for',
    forms: 'Common forms and regimes',
    cta: 'Discuss your situation',
    ctaText: 'Every engagement begins with understanding your circumstances. Request a strategic consultation to get started.',
  },
  services: {
    strategic: {
      name: 'Strategic Tax Planning',
      short: 'Tax planning for U.S. business owners, investors and complex business situations.',
      h1: 'Strategic tax planning for consequential decisions.',
      intro:
        'Good tax outcomes are rarely the result of filing season. They come from understanding the implications of decisions before they are made — and revisiting them as circumstances change.',
      scope: [
        'Year-round tax planning for business owners and investors',
        'Analysis of the tax impact of significant transactions and decisions',
        'Review of entity selection and ownership structure',
        'Owner compensation and distribution considerations',
        'Planning for estimated taxes and cash-flow timing',
        'Multi-year planning as the business or investment portfolio evolves',
      ],
      whoFor: [
        'Business owners with growing or changing operations',
        'Investors with multiple income sources or entities',
        'Clients facing a sale, acquisition, expansion or restructuring',
      ],
    },
    international: {
      name: 'International & Cross-Border Tax',
      short: 'Foreign-owned U.S. entities, international information reporting, FIRPTA and treaty considerations.',
      h1: 'International and cross-border tax compliance.',
      intro:
        'When people, entities or income cross borders, U.S. tax obligations multiply — and many of them are informational filings with significant penalties for non-compliance. We help clients understand which rules apply and meet them consistently.',
      scope: [
        'Tax compliance for foreign-owned U.S. entities',
        'International information reporting',
        'Nonresident individual and foreign corporation returns',
        'Foreign tax credit considerations',
        'Cross-border ownership and transactions',
        'FIRPTA tax compliance on dispositions of U.S. real property interests',
        'Review of relevant tax treaty considerations',
      ],
      forms: ['Form 5471', 'Form 5472', 'Form 8865', 'Form 1040-NR', 'Form 1120-F', 'FIRPTA'],
      whoFor: [
        'Foreign individuals and companies that own U.S. entities or property',
        'U.S. persons with interests in foreign corporations or partnerships',
        'Businesses with cross-border owners, operations or transactions',
      ],
    },
    realestate: {
      name: 'U.S. Investment & Real Estate Tax',
      short: 'Tax considerations for foreign investors, rental properties, ownership structures and real estate transactions.',
      h1: 'U.S. investment and real estate tax.',
      intro:
        'Real estate is often the first U.S. investment for international clients. The way a property is acquired, held, rented and eventually sold each carries tax consequences. We help investors understand them and stay compliant throughout the life of the investment.',
      scope: [
        'Tax considerations before acquiring U.S. real estate',
        'Analysis of ownership structures from a tax perspective',
        'Tax reporting for rental properties',
        'Tax implications of sales and other real estate transactions',
        'FIRPTA considerations for foreign sellers',
        'Coordination of legal structuring and estate planning with qualified attorneys where appropriate',
      ],
      whoFor: [
        'Foreign investors buying or holding U.S. property',
        'Owners of rental properties in the United States',
        'Investors planning a sale, exchange or restructuring of real estate holdings',
      ],
    },
    business: {
      name: 'Business Tax & Complex Compliance',
      short: 'Business tax preparation and compliance for partnerships, corporations, S corporations and complex ownership structures.',
      h1: 'Business tax and complex compliance.',
      intro:
        'Compliance for businesses with multiple owners, entities or jurisdictions requires more than completing forms. It requires understanding how the pieces fit together. We prepare and coordinate business tax filings with that full picture in mind.',
      scope: [
        'Federal and state business tax return preparation',
        'Partnership returns and owner reporting',
        'C corporation and S corporation compliance',
        'Multi-entity and complex ownership structures',
        'Coordination between accounting records and tax filings',
        'Responses to routine tax notices related to our engagements',
      ],
      whoFor: [
        'Partnerships and multi-member LLCs',
        'Corporations and S corporations',
        'Groups with several related entities or foreign owners',
      ],
    },
    accounting: {
      name: 'Accounting & Ongoing Advisory',
      short: 'Accounting, bookkeeping, financial reporting and tax-ready records, with ongoing advisory.',
      h1: 'Accounting that supports better decisions.',
      intro:
        'Reliable numbers are the foundation of good tax planning. Our accounting services keep your records accurate and tax-ready, and give you the financial reporting you need to run the business with confidence.',
      scope: [
        'Accounting and bookkeeping',
        'Financial reporting',
        'Tax-ready financial records',
        'Ongoing accounting advisory',
        'Payroll and sales tax support, where applicable',
      ],
      whoFor: [
        'Businesses that want their books aligned with their tax strategy',
        'Owners who need timely, consistent financial information',
        'Clients of our tax practice who prefer an integrated approach',
      ],
    },
  },
  howWeWork: {
    overline: 'How We Work',
    h1: 'Clear engagements, built around your situation.',
    intro:
      'We do not sell one-size-fits-all packages. Every relationship begins with understanding your circumstances, and every proposal is tailored to the scope and complexity of the work.',
    processTitle: 'Our process',
    modelsTitle: 'Engagement models',
    models: [
      {
        name: 'Strategic Consultation',
        priceNote: 'Arranged after we review your request',
        text: 'A focused session with a founder to review your situation, identify the key questions and outline possible next steps.',
        badge: 'Starting point',
      },
      {
        name: 'Project-Based Tax Advisory',
        priceNote: 'Quoted by scope and complexity',
        text: 'Defined projects such as the analysis of a transaction, a structure review or a specific compliance matter.',
      },
      {
        name: 'Ongoing Strategic Advisory',
        priceNote: 'Recurring engagement, quoted individually',
        text: 'Year-round access to strategic tax advice as your business or investments evolve.',
      },
      {
        name: 'Tax Compliance & Accounting',
        priceNote: 'Quoted by entity type, obligations, complexity and frequency',
        text: 'Preparation of returns and information reports, and accounting services sized to your needs.',
      },
    ],
    note: 'Every engagement is evaluated individually and quoted according to its scope and complexity. Terms are confirmed in writing before any work begins.',
  },
  plansPage: {
    overline: 'Accounting & Advisory Plans',
    h1: 'Accounting support that matches the rhythm of your business.',
    intro: 'Four plans, from annual compliance to monthly bookkeeping. Every plan coordinates your bookkeeping with your federal and state tax filings, and complements our strategic and international tax advisory.',
    labels: { idealFor: 'Ideal for', bookkeeping: 'Bookkeeping', tax: 'Tax compliance & coordination', meetings: 'Meetings & communication', frequency: 'Frequency' },
    frequency: { basic: 'Annual', 'basic-plus': 'Annual', quarterly: 'Quarterly', monthly: 'Monthly' },
    diff: {
      basic: 'Low transaction volume · one bank account',
      'basic-plus': 'Higher transaction volume · multiple bank accounts',
      quarterly: 'Quarterly reviews · estimated tax guidance · quarterly meeting',
      monthly: 'Monthly reporting · quarterly meetings · ongoing email communication',
    },
    cta: 'Request a Custom Proposal',
    view: 'View Plan Details',
    close: 'Close details',
    summaryTitle: 'Choosing the right rhythm',
    summary: [
      { t: 'Annual — Basic & Basic Plus', d: 'Year-end bookkeeping and tax compliance for businesses that do not need monthly accounting. Basic suits low transaction volume and one bank account; Basic Plus handles higher volume and multiple accounts.' },
      { t: 'Quarterly', d: 'Quarterly bookkeeping and financial reviews, quarterly financial statements, estimated tax guidance when applicable, and one quarterly review meeting.' },
      { t: 'Monthly', d: 'Monthly bookkeeping and reporting for continuous oversight, with a review meeting each quarter and ongoing email communication.' },
    ],
    note: 'Each engagement is evaluated individually and quoted according to transaction volume, accounts and needs. Terms are confirmed in writing before any work begins.',
    teaser: { overline: 'Accounting Plans', title: 'Reliable accounting, sized to your business.', text: 'Basic, Basic Plus, Quarterly and Monthly — from annual compliance to monthly bookkeeping, coordinated with your tax filings.', cta: 'Compare accounting plans' },
  },
  about: {
    overline: 'About Bullish',
    h1: 'An independent, founder-led tax and advisory firm.',
    paragraphs: [
      'Bullish was founded to offer business owners and international investors something that is often hard to find: senior, strategic attention to their U.S. tax matters, in English and Spanish.',
      'We keep our practice focused. That allows the founders to stay directly involved in every relationship and to think beyond the annual return — about structure, timing and the decisions ahead.',
      'BULLISH Tax & Advisory is the brand under which Bullish Accounting LLC provides its services.',
    ],
    principlesTitle: 'What guides our work',
    principles: [
      { title: 'Strategy first', text: 'We start with your objectives and work backwards to the right structure and compliance.' },
      { title: 'Candor', text: 'We tell you what we see — including when a question is outside our scope and another professional is needed.' },
      { title: 'Continuity', text: 'Long-term relationships allow us to understand your situation in depth.' },
    ],
    leadershipTitle: 'Leadership',
    independence:
      'Bullish Accounting LLC is an independent firm. It is not a CPA firm and does not provide audit, attest or other services that require a CPA license.',
  },
  founders: [
    {
      name: 'Leonardo Rifa',
      role: 'Co-Founder',
      initials: 'LR',
      credential: 'University degree in Economics',
      bio: 'Leonardo is a co-founder of Bullish and a tax and accounting professional. He holds a university degree in Economics and works directly with the firm’s clients.',
      email: 'lrifa@bullishaccounting.com',
    },
    {
      name: 'Daniel Lariot',
      role: 'Co-Founder',
      initials: 'DL',
      credential: 'University degree in Accounting and Finance',
      bio: 'Daniel is a co-founder of Bullish. He holds a university degree in Accounting and Finance and works directly with the firm’s clients.',
      email: 'dlariot@bullishaccounting.com',
    },
  ],
  insights: {
    overline: 'Insights',
    h1: 'Insights and educational resources.',
    intro: 'Practical perspectives on U.S. tax planning and cross-border compliance. Our first articles are in preparation.',
    topicsTitle: 'Upcoming topics',
    topics: [
      'U.S. tax planning for business owners',
      'U.S. tax basics for international investors',
      'FIRPTA: what foreign sellers of U.S. real estate should know',
      'Foreign-owned LLCs and Form 5472',
      'Cross-border compliance and information reporting',
    ],
    empty: 'No articles have been published yet.',
  },
  book: {
    overline: 'Request a Strategy Session',
    h1: 'Tell us about your situation.',
    intro:
      'Share a few details and we will review your request. If it fits our practice, we will contact you to arrange a strategic consultation and explain how we can work together.',
    steps: ['Submit your request', 'We review it individually', 'We contact you with next steps'],
    notConfirmed: 'Submitting this form does not confirm an appointment or create an advisory relationship.',
    notice:
      'Please do not include Social Security numbers, tax ID numbers, bank details, tax returns or other documents in this form. If an engagement begins, we will provide a secure method for sharing documents.',
    form: {
      name: 'Full name',
      email: 'Email',
      phone: 'Phone (optional)',
      category: 'Which best describes you?',
      country: 'Country of residence',
      service: 'Primary service needed',
      language: 'Preferred language',
      message: 'Briefly describe your situation',
      messagePlaceholder: 'What decision or question are you facing? Avoid sensitive personal or financial data.',
      select: 'Select…',
      submit: 'Request a Strategy Session',
      planPrefix: 'I would like a custom proposal for the accounting plan:',
      sending: 'Sending…',
      success: 'Thank you. Your request has been received. This is not an appointment confirmation — we will review it and contact you with next steps.',
      consent: 'I agree that Bullish Accounting LLC may use the information in this form to review and respond to my request, as described in the',
      consentLink: 'Privacy Policy',
      required: 'Please complete this field.',
      invalidEmail: 'Please enter a valid email address.',
      consentRequired: 'Please accept the privacy terms to submit your request.',
      error: 'There was a problem sending your request. Please try again.',
      rateLimited: 'You have sent several requests recently. Please try again later.',
    },
    categories: [
      { value: 'international_investor', label: 'International investor / U.S. real estate' },
      { value: 'business_owner', label: 'Business owner / growing company' },
      { value: 'other', label: 'Other' },
    ],
    serviceOther: { value: 'not_sure', label: 'Not sure yet' },
    languages: [
      { value: 'en', label: 'English' },
      { value: 'es', label: 'Español' },
    ],
    contactTitle: 'Direct contact',
    qrTitle: 'Save our contact',
    qrText: 'Scan to add Bullish to your phone contacts.',
  },
  testimonials: {
    overline: 'Client Testimonials',
    title: 'What our clients say',
    count: (n) => (n === 1 ? '1 client has shared their experience' : `${n} clients have shared their experience`),
    swipe: 'Swipe to see more',
    formTitle: 'Share your experience',
    formText: 'Comments are reviewed before being published.',
    name: 'Name',
    email: 'Email',
    comment: 'Your comment',
    commentPlaceholder: 'Share your experience working with Bullish…',
    rating: 'Rating',
    submit: 'Submit Comment',
    sending: 'Submitting…',
    success: 'Thank you for your feedback! Your comment will be reviewed before being published.',
    error: 'There was a problem submitting your comment. Please try again.',
    emptyTitle: 'Client perspectives',
    empty: 'We are building long-term relationships, one engagement at a time. Reviews from our clients will be shared here as they are published.',
    emptyCta: 'Have you worked with us? We would value your perspective.',
    required: 'Please complete this field.',
    invalidEmail: 'Please enter a valid email address.',
  },
  review: {
    overline: 'Client Reviews',
    h1: 'Thank you for trusting Bullish.',
    intro: 'Your perspective helps us serve every client better. Share a few words about your experience working with our team — every review is read by the founders.',
    privacy: 'Reviews are published only after approval by our team. If published, your name, rating and comment are shown; your email is never published. See our',
    googleTitle: 'Prefer to review us on Google?',
    googleText: 'You can also share a public review on our Google Business Profile.',
    googleCta: 'Review us on Google',
  },
  whatsapp: {
    label: (name) => `Message ${name} on WhatsApp`,
    message: 'Hello, I visited the Bullish Accounting website and would like more information about your tax advisory services.',
  },
  footer: {
    expertise: 'Services',
    firm: 'Firm',
    legal: 'Legal',
    follow: 'Follow',
    rights: 'All rights reserved.',
    review: 'Leave a Review',
    disclaimer:
      'Bullish Accounting LLC is not a CPA firm and does not provide audit or attest services. Information on this website is general in nature and is not tax, legal or financial advice. No advisory relationship is created until an engagement agreement is signed.',
  },
  legal: {
    privacy: {
      h1: 'Privacy Policy',
      sections: [
        { h: 'Who is responsible', p: 'This website, bullishaccounting.com, is operated by Bullish Accounting LLC, which provides its services under the BULLISH Tax & Advisory brand. Bullish Accounting LLC is responsible for the personal information collected through this website. Questions about this policy can be sent to lrifa@bullishaccounting.com.' },
        {
          h: 'Information you provide',
          p: [
            'Consultation and contact form: your name, email address, optional phone number, client category, country of residence, the service you are interested in, your preferred language and your message. When you request a proposal for one of our Accounting Plans, the name of the selected plan is added to your message.',
            'Testimonial form: your name, email address, star rating and comment.',
            'This website does not ask for Social Security numbers, tax identification numbers, bank details or tax documents. Please do not include them in your message.',
          ],
        },
        { h: 'Privacy consent record', p: 'Before a consultation request can be sent, you must confirm that you agree to the use of your information as described in this policy. We store a record of that confirmation together with your request and the date and time it was received.' },
        {
          h: 'Technical and security information',
          p: [
            'To protect the website against spam and abuse, our server uses your IP address to limit repeated form submissions and repeated sign-in or password-reset attempts. These temporary security records are deleted automatically, generally within one hour. The forms also contain a hidden field used to detect automated spam.',
            'Sign-in attempts to the administration area, which is used only by authorized members of our team, are recorded for a limited time to prevent unauthorized access.',
            'Like most websites, our hosting infrastructure may process standard technical information, such as your IP address and browser details, in order to deliver pages and keep the service secure.',
          ],
        },
        { h: 'How we use information', p: 'We use the information you provide to respond to your request, evaluate whether and how we can assist you, prepare a proposal when requested, and communicate with you about a potential engagement. We use testimonial submissions to review and, if approved, publish your testimonial. We use technical information only to operate and protect the website.' },
        { h: 'Testimonials', p: 'Testimonials submitted through the website are stored as pending and are reviewed by our team before anything is published. If a testimonial is approved, your name, rating and comment are displayed on the website; your email address is never published. Testimonials that are not approved are deleted.' },
        {
          h: 'Service providers',
          p: [
            'We use a hosting and cloud infrastructure provider on which the website and its database operate, and an email delivery provider that sends notifications to our team. When you submit a form, the details you provide are sent by email to our business email account so that we can respond. These providers process information on our behalf to provide their services.',
            'We have not installed third-party analytics, advertising or marketing-tracking tools on this website, and its fonts and images are served from our own website rather than from external services. If you follow our link to Instagram, you leave this website and Instagram’s own privacy policy applies.',
          ],
        },
        {
          h: 'Cookies and similar technologies',
          p: [
            'The website’s own code does not use cookies or browser storage for analytics, advertising or tracking. It sets only one cookie: a strictly necessary security cookie created when an authorized administrator signs in to the administration area. Visitors who do not sign in do not receive it.',
            'Our hosting and network providers may set their own technical cookies when pages are delivered, for example to manage connections and to protect the website against automated traffic. We do not use these cookies for advertising or marketing.',
          ],
        },
        { h: 'Retention and deletion', p: 'We have not set a fixed retention period. Consultation requests and approved testimonials remain stored in our records until they are deleted, and copies of form notifications remain in our business email account until they are deleted. Testimonials that are not approved are deleted, and temporary security records are deleted automatically. You may ask us to delete your information at any time, as described below.' },
        { h: 'Security', p: 'We use reasonable measures to protect information, including encrypted connections, password-protected administrative access limited to authorized members of our team, and protections against spam and repeated sign-in attempts. No website or method of transmission over the internet is completely secure, and we cannot guarantee absolute security.' },
        { h: 'Your requests', p: 'You may ask to access, correct or delete the personal information you submitted through this website by writing to lrifa@bullishaccounting.com. We may need to confirm your identity before acting on a request.' },
        { h: 'Updates', p: 'We may update this policy. The current version will always be published on this page.' },
      ],
    },
    terms: {
      h1: 'Terms of Use',
      sections: [
        { h: 'Use of this website', p: 'This website is provided by Bullish Accounting LLC, which operates under the BULLISH Tax & Advisory brand, for general information about the firm and its services. By using the website you agree to these terms. If you do not agree, please do not use the website.' },
        { h: 'No individualized advice', p: 'Content on this website is general and educational. It is not individualized tax, legal, accounting or financial advice, and it should not be relied upon without a review of your specific facts and circumstances by a qualified professional.' },
        { h: 'No client relationship', p: 'Submitting a consultation request or testimonial, or sending us an email, does not by itself create a client or professional relationship with Bullish Accounting LLC. A professional engagement begins only after the applicable engagement agreement, setting out the scope and terms of the work, has been accepted by the parties. Please do not send confidential documents before an engagement is in place.' },
        { h: 'Accounting Plans and proposals', p: 'Descriptions of our services and Accounting Plans are general. The scope, deliverables and fees of any engagement are confirmed individually in writing before work begins.' },
        { h: 'Brand materials', p: 'The BULLISH name, the original bull logo, the BA monogram and the original text and design of this website are brand materials of Bullish Accounting LLC and may not be copied or used without permission.' },
        { h: 'Licensed images and third-party content', p: 'Some photographs on this website are licensed from third parties and are not owned by Bullish Accounting LLC. They remain subject to their respective licenses. Links to third-party websites, such as Instagram, are provided for convenience; we do not control those websites and are not responsible for their content or practices.' },
        { h: 'Testimonials', p: 'By submitting a testimonial you confirm that it reflects your own genuine experience. We review every testimonial before publication and may decline or remove any testimonial. Approved testimonials display your name, rating and comment.' },
        { h: 'Acceptable use', p: 'You agree not to misuse this website, including by submitting false or automated requests, sending spam, or attempting to access restricted areas or interfere with its operation.' },
        { h: 'Accuracy of information', p: 'We aim to keep the information on this website accurate and current, but tax laws and regulations change and some content may become outdated. We do not guarantee that the website is complete, current or free of errors.' },
        { h: 'Limitation of liability', p: 'To the extent permitted by applicable law, Bullish Accounting LLC is not responsible for losses arising from reliance on the general information published on this website without a professional engagement. Nothing in these terms limits any liability that cannot be limited under applicable law, or any obligations set out in a signed engagement agreement.' },
        { h: 'Changes to these terms', p: 'We may update these terms. The current version will always be published on this page.' },
        { h: 'Governing law', p: 'These terms are governed by the laws of the State of Florida, United States, without regard to its conflict-of-law rules. Any dispute arising from the use of this website will be subject to the jurisdiction of the competent courts located in the State of Florida.' },
      ],
    },
    disclaimer: {
      h1: 'Professional Services Disclaimer',
      sections: [
        { h: 'Our services', p: 'Bullish Accounting LLC provides tax compliance, tax planning, accounting and advisory services within the scope of the qualifications and authorizations that apply to the firm and its team.' },
        { h: 'Not a CPA firm or law firm', p: 'Bullish Accounting LLC is not a CPA firm and does not provide audit, review, attest or other services reserved for licensed certified public accountants. It is not a law firm and does not provide legal advice. Nothing on this website states or implies that our founders hold CPA licenses or Enrolled Agent credentials.' },
        { h: 'Matters requiring specific authorization', p: 'Some matters require a licensed professional, an attorney or another specific authorization. Such services are not offered unless the appropriate qualifications and arrangements are in place. When a matter requires them, we will tell you and, where appropriate, coordinate with or refer you to qualified professionals.' },
        { h: 'No individualized advice', p: 'Information on this website is general in nature. It is not individualized professional advice and should not be relied upon for your specific situation.' },
        { h: 'No guaranteed results', p: 'Tax outcomes depend on each client’s facts and circumstances and on applicable law, which changes over time. We do not guarantee any particular tax result or tax savings. Each matter requires individual analysis.' },
        { h: 'Professional engagement', p: 'Professional services are provided only under an engagement agreement accepted by the parties, which sets out the scope of the work.' },
      ],
    },
  },
  admin: { noindex: true },
};

export default en;
